import { render, staticRenderFns } from "./orderListAddress.vue?vue&type=template&id=3dc41718&scoped=true&"
import script from "./orderListAddress.vue?vue&type=script&lang=js&"
export * from "./orderListAddress.vue?vue&type=script&lang=js&"
import style0 from "./orderListAddress.vue?vue&type=style&index=0&id=3dc41718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc41718",
  null
  
)

export default component.exports